import OrderFormList from './order_form_list.vue'

export default {
    name: 'orderFormList',
    path: 'orderFormList',
    component: OrderFormList
}
